var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import noop from 'lodash-es/noop';
import { createContext, useContext } from 'react';
import formatDateStringNoTimezone from 'syf-js-utilities/formats/formatDateStringNoTimezone';
var context = createContext({
    changeTab: noop,
    changeModal: noop,
    closeModal: noop,
    currentTransaction: undefined,
    disputesEnabled: false,
    disputesLinkEnabled: false,
    handleNavigate: noop
});
export var TransactionProvider = context.Provider;
var useTransaction = function () {
    var _a, _b, _c, _d, _e, _f;
    var value = useContext(context);
    var currentTransaction = value.currentTransaction;
    var referenceValue = (_a = currentTransaction === null || currentTransaction === void 0 ? void 0 : currentTransaction.identifiers) === null || _a === void 0 ? void 0 : _a.find(function (identifier) { return identifier.idType === 'EXPANDED_REFERENCE_NUMBER'; });
    var referenceId = (_b = referenceValue === null || referenceValue === void 0 ? void 0 : referenceValue.id) !== null && _b !== void 0 ? _b : '';
    var positiveAmount;
    if (Number(currentTransaction === null || currentTransaction === void 0 ? void 0 : currentTransaction.amount) < 0) {
        positiveAmount = currentTransaction === null || currentTransaction === void 0 ? void 0 : currentTransaction.amount.slice(1);
    }
    else {
        positiveAmount = currentTransaction === null || currentTransaction === void 0 ? void 0 : currentTransaction.amount;
    }
    var transactionDetails = {
        transactionId: (_c = currentTransaction === null || currentTransaction === void 0 ? void 0 : currentTransaction.transactionInfo) === null || _c === void 0 ? void 0 : _c.skuReferenceNumber,
        merchantName: ((_e = (_d = currentTransaction === null || currentTransaction === void 0 ? void 0 : currentTransaction.transactionInfo) === null || _d === void 0 ? void 0 : _d.merchant) === null || _e === void 0 ? void 0 : _e.description) || '',
        referenceNumber: referenceId,
        transactionCode: (_f = currentTransaction === null || currentTransaction === void 0 ? void 0 : currentTransaction.transactionInfo) === null || _f === void 0 ? void 0 : _f.transactionCode,
        transactionDate: currentTransaction && (currentTransaction === null || currentTransaction === void 0 ? void 0 : currentTransaction.postedDate)
            ? formatDateStringNoTimezone(currentTransaction === null || currentTransaction === void 0 ? void 0 : currentTransaction.postedDate)
            : '',
        transactionAmount: positiveAmount,
        statementDate: (currentTransaction === null || currentTransaction === void 0 ? void 0 : currentTransaction.statementDate) || '',
        merchantDesc: (currentTransaction === null || currentTransaction === void 0 ? void 0 : currentTransaction.description) || ''
    };
    return __assign(__assign({}, value), { transactionDetails: transactionDetails });
};
export default useTransaction;
//# sourceMappingURL=use-transaction.js.map